// A one-shot request carried across a navigation: the profile menu's "Poner un estado" opens the
// settings page AND its custom-status editor. Consumed by the section that owns it, once.
type Intent = 'customStatus' | null;
let pending: Intent = null;

export function requestIntent(i: Intent): void {
  pending = i;
}

export function takeIntent(i: Exclude<Intent, null>): boolean {
  if (pending !== i) return false;
  pending = null;
  return true;
}
